export const ASTIROIDS_BLACK = '#000000';
export const ASTIROIDS_WHITE = '#FFFFFF';
export const ASTIROIDS_GRAY = '#1b1b1b';